export const CoverType = Object.freeze({
  HOSPITAL_ONLY: 'Hospital only',
  EXTRAS_ONLY: 'Extras only',
  PACKAGE: 'Hospital and Extras',
});

export default CoverType;
